import { Box, Chip, useTheme } from '@mui/material';
import { FC } from 'react';
import { FullPolicy, PolicyStatus } from '@acorn-portal/shared/src/services/api';

interface Props {
	policy: FullPolicy;
}

const PolicyStatusField: FC<Props> = ({ policy }: Props) => {
	const themeUtils = useTheme();

	let text = '';
	let statusColor = '';

	const getRenewalText = () => {
		if (policy.renewalDeclined) {
			return 'Your Policy Is Due To Expire';
		}
		if (policy.autoRenewal) {
			return 'Your Policy Will Automatically Renew';
		}
		return 'Your Policy Will Expire Soon';
	};

	const getRenewalStatusColor = () => {
		if (policy.renewalDeclined) {
			return themeUtils.palette.warning.dark;
		}
		if (policy.autoRenewal) {
			return themeUtils.palette.success.main;
		}
		return themeUtils.palette.warning.dark;
	};

	switch (policy.policyStatus) {
		case PolicyStatus.EndOfProduct:
			text = 'Your Policy Is Due To Expire';
			statusColor = themeUtils.palette.warning.dark;
			break;
		case PolicyStatus.Active:
			text = "You're Covered";
			statusColor = themeUtils.palette.success.main;
			break;
		case PolicyStatus.RenewalTakenUp:
			text = 'Your Renewal has Been Purchased';
			statusColor = themeUtils.palette.success.main;
			break;
		case PolicyStatus.DueForRenewal:
		case PolicyStatus.DueToExpire:
			text = getRenewalText();
			statusColor = getRenewalStatusColor();
			break;
		case PolicyStatus.Cancelled:
			text = 'Policy Cancelled';
			statusColor = themeUtils.palette.error.main;
			break;
		case PolicyStatus.Expired:
			text = 'Policy Expired';
			statusColor = themeUtils.palette.text.disabled;
			break;
		case PolicyStatus.Pending:
			text = 'Pending Cover';
			statusColor = themeUtils.palette.warning.light;
			break;
		case PolicyStatus.CancellationPending:
			text = 'Cancellation Pending';
			statusColor = themeUtils.palette.text.secondary;
			break;
		default:
			break;
	}
	return (
		<Box marginTop={2}>
			<Box display='flex'>
				<Chip
					sx={{
						backgroundColor: statusColor,
						color: 'white',
						fontSize: '1.2rem',
						fontWeight: 500,
						borderRadius: 2,
					}}
					label={text}
				/>
			</Box>
		</Box>
	);
};

export default PolicyStatusField;
